import { Button, Center, Flex, Heading, HStack, Link, Text, VStack } from '@chakra-ui/react'
import { FunctionComponent, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import Card from '../../common/components/Card'
import { Logo } from '../../components/shared-components/Logo'
import { cognitoLoginUrl } from '../../features/authentication/hostedUiUrls'
import { LOGGED_OUT_SOURCE_PARAM } from '../../features/authentication/loggedOutUrl'
import { FRESH_LOGIN_PARAM } from '../../features/sso'

const LoggedOutPage: FunctionComponent<unknown> = () => {
  const [searchParams] = useSearchParams()
  const [isSigningIn, setIsSigningIn] = useState(false)

  const clientName = searchParams.get(LOGGED_OUT_SOURCE_PARAM)
  const isFreshLogin = searchParams.get(FRESH_LOGIN_PARAM) === '1'
  const signInHref = clientName
    ? `/sso/${encodeURIComponent(clientName)}${isFreshLogin ? `?${FRESH_LOGIN_PARAM}=1` : ''}`
    : cognitoLoginUrl()

  // Sign-in is several redirects. Hold the button in its loading state for the
  // rest of this document's life so the page does not look inert while they run.
  const handleSignIn = () => {
    setIsSigningIn(true)
  }

  return (
    <Flex height="100%" flexDirection="column" p={10}>
      <HStack mt={20}>
        <VStack spacing="16" width="100%">
          <Card variant="light" padding="8" width="90%" maxWidth="500px">
            <VStack spacing="20px" alignItems="stretch">
              <Center>
                <Logo maxWidth={150} />
              </Center>
              <Heading as="h2" alignSelf="center" size="lg">
                You&apos;ve been signed out
              </Heading>
              <Text alignSelf="center">Your RxPad session has ended.</Text>
              <Link href={signInHref} onClick={handleSignIn}>
                <Button
                  colorScheme="blue"
                  alignSelf="center"
                  isLoading={isSigningIn}
                  loadingText="Signing you in"
                  style={{ width: '100%' }}
                >
                  Sign in again
                </Button>
              </Link>
            </VStack>
          </Card>
        </VStack>
      </HStack>
    </Flex>
  )
}

export default LoggedOutPage
